import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

type Dictionary<T extends DictionaryKey, U> = {
  [K in T]?: U;
};

type DictionaryKey = string | number | symbol;
export type LoaderType = 'local'
  | 'quote-loading'
  | 'vin-loading'
  | 'lead-loading'
  | 'configurable-table-loading'
  | string;

export class Loader {
  private static _instance: Loader;
  private lockers: Dictionary<LoaderType, boolean> = {};
  private _lockers$ = new BehaviorSubject<Dictionary<LoaderType, boolean>>({});

  constructor() {}

  get asObservable() {
    return this._lockers$.asObservable();
  }

  public static create() {
    return new Loader();
  }

  public isLoadingObservable(key: LoaderType) {
    return this.asObservable.pipe(
      map(lockers => !!lockers[key]),
    );
  }

  public isLoading(key: LoaderType): boolean {
    return this.lockers[key];
  }

  public lock(key: LoaderType): void {
    this.set(key, true);
    this._lockers$.next(this.lockers);
  }

  public unlock(key: LoaderType): void {
    this.set(key, false);
    this._lockers$.next(this.lockers);
  }

  public set(key: LoaderType, value: boolean) {
    this.lockers[key] = value;
  }

  public add(key: LoaderType, value: boolean = false) {
    this.set(key, value);
    return this;
  }

  public static get instance(): Loader {
    return (this._instance = Boolean(this._instance)
      ? this._instance
      : new Loader().add('configurable-table-loading'));
  }
}
